import type { OnboardingJob } from "../../services/backend.service";

export type OnboardingToolsTab = "auto-prompt" | "data-load" | "recurring" | "db" | "sftp";

export type SelectedOnboardingRunState =
	| { kind: "none" }
	| { kind: "loading" }
	| { kind: "resolved"; job: OnboardingJob; source: "list" | "created" | "detail" }
	| { kind: "not_found" }
	| { kind: "mismatch"; job: OnboardingJob }
	| { kind: "error" };

type SelectedRunResolutionParams = {
	selectedJobId: string | null;
	departmentId: string;
	listLoaded: boolean;
	listError: boolean;
	listedJob: OnboardingJob | undefined;
	createdJob: OnboardingJob | undefined;
	detailLoading: boolean;
	detailError: boolean;
	detailNotFound: boolean;
	detailJob: OnboardingJob | undefined;
};

export const onboardingWorkflowKey = (departmentId: string, tab: OnboardingToolsTab, selectedJobId: string | null): string =>
	`${departmentId}:${tab}:${selectedJobId === null ? "new" : selectedJobId}`;

export const isRestoredJobMismatch = (job: OnboardingJob | undefined, selectedJobId: string | null, departmentId: string): boolean =>
	selectedJobId !== null && (!job || job.department_id !== departmentId);

export const resolveSelectedOnboardingRun = (params: SelectedRunResolutionParams): SelectedOnboardingRunState => {
	if (params.selectedJobId === null) return { kind: "none" };
	if (params.listError) return { kind: "error" };
	if (!params.listLoaded) return { kind: "loading" };

	const listedJob = params.listedJob?.id === params.selectedJobId ? params.listedJob : undefined;
	const createdJob = params.createdJob?.id === params.selectedJobId ? params.createdJob : undefined;
	const localJob = listedJob ? listedJob : createdJob;
	if (localJob)
		return localJob.department_id === params.departmentId
			? { kind: "resolved", job: localJob, source: listedJob ? "list" : "created" }
			: { kind: "mismatch", job: localJob };
	if (params.detailLoading) return { kind: "loading" };
	if (params.detailNotFound) return { kind: "not_found" };
	if (params.detailError) return { kind: "error" };
	if (!params.detailJob) return { kind: "loading" };
	return params.detailJob.department_id === params.departmentId
		? { kind: "resolved", job: params.detailJob, source: "detail" }
		: { kind: "mismatch", job: params.detailJob };
};
